import { render, staticRenderFns } from "./ShareLinks.vue?vue&type=template&id=2859facc"
import script from "./ShareLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareLinks.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CopyButton: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/CopyButton.vue').default})
